import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./PagoDistribuidor.module.css";

export const PagoDistribuidor = ({
  total,
  handleScrollToTop,
  handleClose,
  saldo,
  balance,
  facturas,
  totalMesesActuales,
  totalFacturasSiHayIntereses,
  facturaViejas
}) => {
  const [cantidad, setCantidad] = useState("");
  const [pagoSeleccionado, setPagoSeleccionado] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Solo sumamos totalMesesActuales si hay facturas viejas
  let MAX_CANTIDAD = pagoSeleccionado === "parcial"
    ? (Number(saldo) + (facturaViejas.length > 0 ? Number(totalMesesActuales || 0) : 0)).toFixed(2)
    : Number(saldo).toFixed(2);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleChange = (e) => {
    let value = e.target.value;
    if (value === "0") {
      toast.error("El valor no puede ser solo $0");
      return;
    }
    if (/^0\d+/.test(value)) {
      toast.error("El valor no puede comenzar con $0");
      return;
    }
    if (/^\d*\.?\d*$/.test(value)) {
      const parsedValue = parseFloat(value);
      if (value === "" || parsedValue <= MAX_CANTIDAD) {
        setCantidad(value);
      } else {
        toast.error(`La cantidad no puede ser mayor a $${MAX_CANTIDAD}`);
      }
    } else {
      toast.error("Ingrese un número válido");
    }
  };

  const handleSubmit = async () => {
    if (isLoading) return; // Evita múltiples clics

    setIsLoading(true);

    if (pagoSeleccionado === "total") {
      if (facturaViejas.length > 0) {
        toast.info("Saldo pendiente a pagar de meses anteriores");
      }
      await handleScrollToTop(saldo, "total");
    } else if (pagoSeleccionado === "parcial") {
      let saldoActualizado = Number(saldo) + (facturaViejas.length > 0 ? Number(totalMesesActuales) : 0);
      let monto = parseFloat(cantidad);

      if (cantidad === "" || monto < 5) {
        toast.error("La cantidad debe ser mayor a $5");
        setIsLoading(false);
        return;
      }
      if (monto > saldoActualizado) {
        toast.error(`La cantidad no puede ser mayor al total a pagar $${saldoActualizado}`);
        setIsLoading(false);
        return;
      }

      await handleScrollToTop(monto, "parcial");
    }

    setIsLoading(false); // Solo se activa después de que todo se haya completado
  };


  const handleCloseClick = () => {
    setIsLoading(false);
    handleClose();
  };

  console.log("facturaViejas", facturaViejas);

  return (
    <div className={styles.containerMain}>
      <div className={styles.contenedor}>
        <button onClick={handleCloseClick} className={styles.closeButton}>
          X
        </button>
        <h2 className={styles.titulo}>
          ${MAX_CANTIDAD} <br />
          <p className={styles.parrafo}>
            {facturaViejas.length > 0 && pagoSeleccionado === "total" ? (
              <>
                <span className={styles.parrafo}>Saldo pendiente a pagar</span>
                <br />
                <span className={styles.parrafo}>de meses anteriores</span>
              </>
            ) : (
              "Saldo pendiente a pagar"
            )}
          </p>
        </h2>
        <div className={styles.lineWhite} />
        <div className={styles.checkboxContainer}>
          <label className={styles.labels}>
            <input
              className={styles.inputs}
              type="radio"
              name="pago"
              value="total"
              checked={pagoSeleccionado === "total"}
              onChange={() => setPagoSeleccionado("total")}
            />
            Pago total
          </label>
          <label className={styles.labels}>
            <input
              className={styles.inputs}
              type="radio"
              name="pago"
              value="parcial"
              checked={pagoSeleccionado === "parcial"}
              onChange={() => setPagoSeleccionado("parcial")}
            />
            Pago parcial
          </label>
        </div>

        {pagoSeleccionado === "parcial" && (
          <input
            type="text"
            placeholder="Ingrese la cantidad"
            className={styles.input}
            value={cantidad}
            onChange={handleChange}
            pattern="\d*"
          />
        )}

        {pagoSeleccionado && (
          isLoading ? (
            <div className={styles.spinner}></div>
          ) : (
            <button
              onClick={handleSubmit}
              className={styles.finalizarCompra}
              disabled={isLoading}
            >
              {isLoading ? "Cargando..." : "Finalizar pago"}
            </button>
          )
        )}

        {facturas > 0 && (
          <p className={styles.parrafos}>Recuerda que tienes un abono en proceso de aplicación.</p>
        )}
      </div>
    </div>
  );
};
